import microuniversoApi from "app/api/microuniversoApi";
import {IOrcamento} from "../../types/IOrcamento";
import store from "../../redux/store/store";
import {sobrescreverInformacoesAction} from "../../redux/orcamentoSlice";
import globalMU from "globalMU";
declare var window: any

export async function atualizarDadosOrcamento(orcamento: IOrcamento) {
    const partial = await microuniversoApi.Orcamento.atualizarDadosOrcamento(orcamento)
    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        const orcamentoReact = store.getState().orcamento
        const novoOrcamento = {
            ...orcamentoReact,
            ...partial
        }
        orcamentoLegado.atualizar(novoOrcamento)
        store.dispatch(sobrescreverInformacoesAction(novoOrcamento))
    } 

    if (partial.ValorTotalMercadorias && orcamento.ValorTotalMercadorias !== partial.ValorTotalMercadorias) {
        if (!partial.AplicaDescontoCashback && partial.SaldoCashbackCliente > 0 
                && orcamento.AplicaDescontoCashback!= partial.AplicaDescontoCashback
                && partial.Situacao == 6) // Situacao == 6 ->SoOrcando
        { // 438892
            global.showInfoMessage("Cashback foi removido</br></br>Valor total das mercadorias foi alterado!");
        }
        else if (!partial.AplicaDescontoCashback && partial.SaldoCashbackCliente <= 0 && orcamento.AplicaDescontoCashback!= partial.AplicaDescontoCashback) { // 438892
            global.showInfoMessage("Saldo do cashback do cliente está zerado.</br>Cashback foi removido</br>Favor analisar os descontos!</br></br>Valor total das mercadorias foi alterado!");
        }
        else {
            globalMU.showInfoMessage("Valor total das mercadorias foi alterado!");
        }
    }

    if (partial && !("HasErrors" in partial) && partial.VendaComAutorizado) {
        globalMU.showInfoMessage("Cliente autorizado não informado.<br>Informe a senha do autorizado para continuar!");
        setTimeout(function () {
            $('#detalhe-resumo-orcamento-region').hide();
            window.orcamentoController.renderizarViewAutorizadoOrcamentoReact();
        }, 3000);
    }


    atualizarOrcamentoLegadoERedux()
}
